var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Const } from './provider/lib/const.cls';
import { mapActions } from 'vuex';
import { support } from './lib/support.cls';
import * as supportStoreExtensions from './provider/';
var state = __assign({}, supportStoreExtensions.stateExt);
var actions = __assign({}, supportStoreExtensions.actionsExt);
var mutations = __assign({}, supportStoreExtensions.mutationsExt);
var getters = __assign({}, supportStoreExtensions.gettersExt);
// new store module definition
var supportStore = {
    state: state,
    actions: actions,
    mutations: mutations,
    getters: getters
};
// main mixin to load the new store module 
export var supportMixins = {
    created: function () {
        var _store = this.$store;
        if (!(_store && _store.state && _store.state[support.STORE_MODULE_NAME])) {
            try {
                this.$store.registerModule(support.STORE_MODULE_NAME, supportStore);
            }
            catch (error) { }
        }
    },
    methods: __assign(__assign({}, mapActions({
        _runGetTicketList: Const.RUN_GET_TICKET_LIST,
        _runGetTicketDetail: Const.RUN_GET_TICKET_DETAIL,
        _runTicketRequestOtp: Const.RUN_TICKET_REQUEST_OTP,
        _runTicketCheckOtp: Const.RUN_TICKET_CHECK_OTP,
        _runTicketReply: Const.RUN_TICKET_REPLY,
        _runGetTicketReasonList: Const.RUN_GET_TICKET_REASON_LIST,
        _runTicketResendOtp: Const.RUN_TICKET_RESEND_OTP
    })), { computedSupportFunc: function (getFuncName) {
            try {
                return this.$store.getters[getFuncName];
            }
            catch (ex) {
                return [];
            }
        } }),
    computed: {
        ticketData: function () { return this.computedCommonFunc(Const.GET_TICKET_DATA); },
        ticketList: function () { return this.computedCommonFunc(Const.GET_TICKET_LIST); },
        ticketView: function () { return this.computedCommonFunc(Const.GET_TICKET_VIEW); },
        ticketReasonList: function () { return this.computedCommonFunc(Const.GET_TICKET_REASON_LIST); }
    }
};
export default supportMixins;



//////////////////
// WEBPACK FOOTER
// ./src/plugins/support/index.ts
// module id = null
// module chunks = 